var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6852 83.2244C61.0625 79.7209 70.7769 61.8327 76.4304 54.1089C76.8422 53.6232 77.0442 52.9938 76.9919 52.3591C76.9396 51.7245 76.6374 51.1366 76.1517 50.7248C75.666 50.313 75.0365 50.111 74.4019 50.1633C73.7672 50.2155 73.1794 50.5178 72.7675 51.0035C65.4864 60.5866 57.5865 69.6835 49.1185 78.2359C52.8241 49.5699 52.622 48 52.622 20.4719C52.622 17.2072 53.2591 11.2611 50.7906 11.5C47.3668 12.5001 47.7648 16.3313 47.3667 20.233C46.4919 49 45.9919 48.5 43.465 75.5286C36.507 66.3743 30.201 56.7422 24.5935 46.7037C24.5935 45.9857 24.3083 45.2971 23.8006 44.7893C23.2929 44.2816 22.6042 43.9964 21.8862 43.9964C21.1682 43.9964 20.4796 44.2816 19.9719 44.7893C19.4642 45.2971 19.1789 45.9857 19.1789 46.7037C19.1789 49.411 35.1042 77.7302 43.0669 82.5078C43.7507 82.9274 44.5112 83.2069 45.3041 83.3299C46.0969 83.453 46.9063 83.4171 47.6852 83.2244Z",
    fill: "#1C1C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.03dd538c198969e4dbf6cdadd98f1d7c.svg";
export { ForwardRef as ReactComponent };